export default function PHP_print() {
  return (
    <div>
      <h1>PHP_print</h1>
    </div>
  );
}
